import { PersonalizationService } from './PersonalizationService';

export const personalizationService: PersonalizationService = new PersonalizationService();
